import { Button, Typography } from "@suraasa/placebo-ui"
import { OfferLetterType } from "api/resources/offerLetter/types"
import { Link } from "react-router-dom"
import routes from "routes"
import useFormatPrice from "utils/hooks/useFormatPrice"

import { usePgCTLOfferLetter } from "../usePgCTLOfferLetter"
import PdfItem from "./PdfItem"

const LetterContent = ({
  offerLetter,
  fullName,
}: {
  offerLetter: OfferLetterType
  fullName: string
}) => {
  const { isRegistrationDone } = usePgCTLOfferLetter()

  const formatPrice = useFormatPrice()

  return (
    <div className="px-2 sm:px-[38px]">
      {offerLetter && (
        <div
          className="mb-3 whitespace-pre-wrap text-body text-onSurface-500"
          dangerouslySetInnerHTML={{
            __html: offerLetter.offerLetter.content
              .replace("{{first_name}} {{last_name}}", fullName)
              .replace(
                "{{registration_fee}}",
                `${offerLetter.registrationFee.currency.symbol} ${formatPrice(
                  offerLetter.registrationFee.price
                )}`
              ),
          }}
        />
      )}
      <div>
        <Typography variant="title3" className="mb-3">
          Review Documents
        </Typography>
        <div className="mb-6 flex flex-col items-center gap-2 sm:mb-7 sm:flex-row">
          {offerLetter?.offerLetter.attachments.map(item => (
            <PdfItem key={item.id} attachment={item} />
          ))}
        </div>
        {!isRegistrationDone && (
          <Link
            to={
              routes.pgctlOnboarding.payment +
              `?product=${offerLetter.product.slug}`
            }
            className="ml-auto block w-fit"
          >
            <Button color="black">Pay Registration Fee</Button>
          </Link>
        )}
      </div>
    </div>
  )
}

export default LetterContent
